export const isDEStore = () => {
 return /www-de[a-z0-9.-]*\.contorion(-quality)?\.net/.test(window.location.host) ||
        /www\.contorion\.de/.test(window.location.host);
};

export const isATStore = () => {
     return /www-at[a-z0-9\-|.]*\.contorion\.net/.test(window.location.host) ||
        /www\.contorion\.at/.test(window.location.host);
};
